//include 28
jQuery(function(){
    var sessionKey = "ppFilters";
    var functions = {
        getSessionKey: function(group){
            group = group || null;
            if(group == null)
                return sessionKey;
            return `${sessionKey}:${group}`;
        },
        get: function(key, defaultValue, group) {
            var sessionKeyToUse = functions.getSessionKey(group);
            defaultValue = defaultValue || null;
            var filters = window.pixelpoint.sessionService.get(sessionKeyToUse);
            if (!key) {
                if (!filters) return null;
                return filters;
            } else {
                if (!!filters || !filters.hasOwnProperty(key)) return defaultValue;
                return filters[key];
            }
        },
        set: function(key, value, group) {
            var sessionKeyToUse = functions.getSessionKey(group);
            var filters = window.pixelpoint.sessionService.get(sessionKeyToUse);
            if (!filters) {
            	filters = {}
                filters[key] = value;
                window.pixelpoint.sessionService.set(sessionKeyToUse, filters);
            } else {            	
                filters[key] = value;
                window.pixelpoint.sessionService.set(sessionKeyToUse, filters);
            }
        },
        delete:function(key,group){
            var sessionKeyToUse = functions.getSessionKey(group);
            var filters = window.pixelpoint.sessionService.get(sessionKeyToUse);
            if(!!filters)
                delete filters[key];
            window.pixelpoint.sessionService.set(sessionKeyToUse, filters);
        },
        clear: function(group) {
            var sessionKeyToUse = functions.getSessionKey(group);
            window.pixelpoint.sessionService.set(sessionKeyToUse, {});
        }
    };
    window.pixelpoint.filterManager = functions;
});